import { ClinicAuthError } from "@auth/clinicAuthClient";

const RATE_LIMIT_ERROR = "Too many attempts. Please try again shortly.";
const NETWORK_ERROR = "Could not reach the server. Check your connection.";
const ACCOUNT_INACTIVE_ERROR = "This account is no longer active.";

export const authErrorMessage = (err: unknown, generic: string): string => {
  const code = err instanceof ClinicAuthError ? err.code : "unknown";
  if (code === "account_inactive") return ACCOUNT_INACTIVE_ERROR;
  if (code === "rate_limited") return RATE_LIMIT_ERROR;
  if (code === "network_error") return NETWORK_ERROR;
  return generic;
};

/** A deactivated account is terminal, so the screen stops inviting retries. */
export const isRecoverable = (err: unknown): boolean =>
  !(err instanceof ClinicAuthError && err.code === "account_inactive");
